<ng-container *ngIf="workflow">
	<nz-page-header *ngIf="workflow.payload.id > 0" nzTitle="Edit Workflow"
		[nzSubtitle]="workflow._name"></nz-page-header>
	<nz-page-header *ngIf="workflow.payload.id <= 0" nzTitle="Create Workflow"></nz-page-header>

	<form [formGroup]="workflow.form">
		<div class="row g-4">
			<div class="col">
				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form" field="name"
							class="me-3"></app-invalid-form-indicator>
						Name
					</nz-form-label>
					<nz-form-control [nzSpan]="18">
						<input nz-input formControlName="name"
							[attr.readonly]="isProductWorkflow || null" />
					</nz-form-control>
				</nz-form-item>

				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form" field="label"
							class="me-3"></app-invalid-form-indicator>
						Label
					</nz-form-label>
					<nz-form-control [nzSpan]="18">
						<input nz-input formControlName="label"
							[attr.readonly]="isProductWorkflow || null" />
					</nz-form-control>
				</nz-form-item>

				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form" field="description"
							class="me-3"></app-invalid-form-indicator>
						Description
					</nz-form-label>
					<nz-form-control [nzSpan]="18">
						<textarea nz-input formControlName="description" rows="3"
							[attr.readonly]="isProductWorkflow || null"></textarea>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form"
							field="referencePrefix"
							class="me-3"></app-invalid-form-indicator>
						Reference Prefix
					</nz-form-label>
					<nz-form-control [nzSpan]="18">
						<input nz-input formControlName="referencePrefix"
							[attr.readonly]="isProductWorkflow || null" />
					</nz-form-control>
				</nz-form-item>

				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form" field="ticketMode"
							class="me-3"></app-invalid-form-indicator>
						Ticket Mode
					</nz-form-label>
					<nz-form-control [nzSpan]="18">
						<nz-select nzMode="default" nzPlaceHolder="Select statuses"
							formControlName="ticketMode"
							*ngIf="!workflow || !workflow.payload.id"
							[nzDisabled]="isProductWorkflow">
							<nz-option nzLabel="Case" nzValue="Case" />
							<nz-option nzLabel="Claim" nzValue="Claim" />
							<nz-option nzLabel="Complaint" nzValue="Complaint" />
						</nz-select>
						<span
							*ngIf="workflow && workflow.payload.id">{{workflow.payload.ticketMode}}</span>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item>
					<nz-form-label [nzSpan]="6">
						<app-invalid-form-indicator [form]="workflow.form"
							field="categoryTemplate"
							class="me-3"></app-invalid-form-indicator>
						Category Template
					</nz-form-label>

					<nz-form-control [nzSpan]="18">
						<app-email-body-editor *ngIf="categoryPlaceholders"
							[placeholders]="categoryPlaceholders"
							formControlName="categoryTemplate"
							[readOnly]="isProductWorkflow">
						</app-email-body-editor>

						<span *ngIf="!categoryPlaceholders">Loading placeholders...</span>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form"
							field="linkToOtherTicketEnabled"
							class="me-3"></app-invalid-form-indicator>
						Can link to another ticket
					</nz-form-label>
					<nz-form-control [nzSpan]="18" class="orange-checkbox">
						<label nz-checkbox formControlName="linkToOtherTicketEnabled"
							[nzDisabled]="isProductWorkflow">Enabled</label>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form" field="autoAssign"
							class="me-3"></app-invalid-form-indicator>
						Auto Assign
					</nz-form-label>
					<nz-form-control [nzSpan]="18" class="orange-checkbox">
						<label nz-checkbox formControlName="autoAssign"
							[nzDisabled]="isProductWorkflow">Enabled</label>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form"
							field="linkMemberships"
							class="me-3"></app-invalid-form-indicator>
						Link Memberships
					</nz-form-label>
					<nz-form-control [nzSpan]="18" class="orange-checkbox">
						<label nz-checkbox formControlName="linkMemberships"
							[nzDisabled]="isProductWorkflow">Enabled</label>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item>
					<nz-form-label [nzSpan]="6" nzRequired>
						<app-invalid-form-indicator [form]="workflow.form"
							field="restrictToPolicies"
							class="me-3"></app-invalid-form-indicator>
						Restrict To Policies
					</nz-form-label>
					<nz-form-control [nzSpan]="18" class="orange-checkbox">
						<label nz-checkbox formControlName="restrictToPolicies"
							[nzDisabled]="isProductWorkflow">Restricted</label>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item>
					<nz-form-label [nzSpan]="6" [nzTooltipTitle]="durationHelp">
						<app-invalid-form-indicator [form]="workflow.form"
							field="slaDurationWarning"
							class="me-3"></app-invalid-form-indicator>
						SLA Duration Warning
					</nz-form-label>
					<nz-form-control [nzSpan]="18"
						nzErrorTip="Please enter a valid duration (e.g. 48h 30m)">
						<input nz-input formControlName="slaDurationWarning"
							[attr.readonly]="isProductWorkflow || null" />
					</nz-form-control>
				</nz-form-item>
				<nz-form-item>
					<nz-form-label [nzSpan]="6" [nzTooltipTitle]="durationHelp">
						<app-invalid-form-indicator [form]="workflow.form"
							field="slaDurationBreach"
							class="me-3"></app-invalid-form-indicator>
						SLA Duration Breach
					</nz-form-label>
					<nz-form-control [nzSpan]="18"
						nzErrorTip="Please enter a valid duration (e.g. 48h 30m)">
						<input nz-input formControlName="slaDurationBreach"
							[attr.readonly]="isProductWorkflow || null" />
					</nz-form-control>
				</nz-form-item>
				<nz-form-item>
					<nz-form-label [nzSpan]="6" [nzTooltipTitle]="durationHelp">
						<app-invalid-form-indicator [form]="workflow.form"
							field="slaDurationEscalation"
							class="me-3"></app-invalid-form-indicator>
						SLA Duration Escalation
					</nz-form-label>
					<nz-form-control [nzSpan]="18"
						nzErrorTip="Please enter a valid duration (e.g. 48h 30m)">
						<input nz-input formControlName="slaDurationEscalation"
							[attr.readonly]="isProductWorkflow || null" />
					</nz-form-control>
				</nz-form-item>
			</div>
			<div class="col">
			</div>
		</div>

		<nz-tabset nzType="card">
			<nz-tab nzTitle="Steps">
				<h4 class="mt-3">Steps</h4>
				<button nz-button nzType="dashed" class="mb-1 me-1" (click)="addStep()"
					[disabled]="isProductWorkflow">+ Add Step</button>
				<nz-steps nzDirection="horizontal" nzLabelPlacement="vertical"
					(nzIndexChange)="selectedStepIndex=$event" [nzCurrent]="selectedStepIndex">
					<nz-step *ngFor="let step of workflow.steps" [nzTitle]="stepLabel"
						[nzSubtitle]="stepLabel"
						[nzStatus]="step.formGroup.valid ? 'process' : 'error'">
						<ng-template #stepLabel>
							<b
								*ngIf="step.payload.id==getActiveStep().payload.id">{{step._label}}</b>
							<span
								*ngIf="step.payload.id!=getActiveStep().payload.id">{{step._label}}</span>
						</ng-template>
					</nz-step>
				</nz-steps>
				<app-workflow-form-step *ngIf="workflow.steps.length != 0" [input]="getActiveStep()"
					[mode]="mode"></app-workflow-form-step>
			</nz-tab>
			<nz-tab nzTitle="Questionnaire" *ngIf="workflow.questionnaire">
				<button nz-button nzType="default" (click)="disableQuestionnaire()"
					[disabled]="isProductWorkflow">Disable Questionnaire</button>
				<app-workflow-form-step [input]="workflow.questionnaire"></app-workflow-form-step>
			</nz-tab>
			<nz-tab nzTitle="Enable Questionnaire" *ngIf="!workflow.questionnaire">
				<button nz-button nzType="default" (click)="enableQuestionnaire()"
					[disabled]="isProductWorkflow">Enable Questionnaire</button>
				<hr>
			</nz-tab>
		</nz-tabset>

		<div class="mt-3" *ngIf="!isProductWorkflow">
			<button class="me-1" nz-button nzType="default" (click)="doCancel()">Cancel</button>
			<button nz-button nzType="default" (click)="saveAsDraft()">
				Save as Draft
			</button>

			<button type="submit" nz-button nzType="primary" *ngIf="workflow.form.valid"
				(click)="doSave()">Save Workflow</button>
			<button *ngIf="!workflow.form.valid" nz-button nzType="default" nz-tooltip
				[nzTooltipTitle]="titleTemplate" (click)="touchAllFields()">
				Save
			</button>
		</div>

		<div class="mt-3" *ngIf="isProductWorkflow">
			<button type="submit" nz-button nzType="primary" [disabled]="!workflow.form.valid"
				(click)="doSave()">Save</button>
		</div>

	</form>


	<ng-template #titleTemplate let-thing>
		<ul>
			<li *ngFor="let item of getInvalidControlsList()">
				<b>{{item.field}}: </b>
				{{item. errors}}
			</li>
		</ul>
	</ng-template>
</ng-container>

<ng-template #durationHelp>
	To specify a duration, you will provide a number followed by it's corresponding unit.
	<ul>
		<li>Year: <code>#</code> [y; year; years]</li>
		<li>Month: <code>#</code> [M; month; months]</li>
		<li>Day: <code>#</code> [d; day; days]</li>
		<li>Week: <code>#</code> [w; week; weeks]</li>
		<li>Hour: <code>#</code> [h; hour; hours]</li>
		<li>Minute: <code>#</code> [m; minute; minutes]</li>
		<li>Second: <code>#</code> [s; second; seconds]</li>
		<li>Work Week: <code>#</code> [ww; work week; work weeks]</li>
		<li>Work Day: <code>#</code> [wd; work day; work days]</li>
		<li>Work Hour: <code>#</code> [wh; work hour; work hours]</li>
	</ul>
	Eg: 1ww 3wd equates to 1 work week and 3 working days or 8 working days
</ng-template>